/**
 * @constant Loading is a full page loading spinner
 */
import React from "react";
import { Loading as CommonLoading } from "@mds/common/components/common/Loading";

const Loading = () => {
  return <CommonLoading />;
};

export default Loading;
